import React, { FC, PropsWithChildren, useContext, useState } from 'react';
import { IAuthToken } from '@wix/ai-scheduling-assistant-domain';
import { decodeToken, isTokenExpired } from '../utils/TokenUtils';

export interface IAuthTokenContext {
  authToken: string | null;
  decodedAuthToken: IAuthToken | null;
  isExpired: boolean;
  setAuthToken: (token: string) => void;
}

export const AuthTokenContext = React.createContext<IAuthTokenContext | null>(null);

function getAuthTokenFromQueryParam(): string | null {
  const url = new URL(window.location.href);
  const params = new URLSearchParams(url.search);

  return params.get('token');
}

export const AuthTokenContextProvider: FC<PropsWithChildren<{}>> = (props) => {
  const { children } = props;
  const [authToken, setToken] = useState<string | null>(getAuthTokenFromQueryParam());

  const setAuthToken = (newToken: string) => {
    const url = new URL(window.location.href);
    const params = new URLSearchParams(url.search);
    params.set('token', newToken);
    window.history.pushState({}, '', `${url.pathname}?${params.toString()}`);

    setToken(newToken);
  };

  const decodedAuthToken = authToken ? decodeToken<IAuthToken>(authToken) : null;
  const isExpired = decodedAuthToken ? isTokenExpired(decodedAuthToken.exp) : false;

  return <AuthTokenContext.Provider value={{ authToken, decodedAuthToken, isExpired, setAuthToken }}>{children}</AuthTokenContext.Provider>;
};

export function useAuthTokenContext() {
  const context = useContext(AuthTokenContext);

  if (!context) {
    throw new Error('AuthTokenContext must be used within an AuthTokenContextProvider');
  }

  return context;
}
